export const MAX_FLIGHTS_PER_EXPORT = 500;

export const FONT_SIZE_TITLE = 16;

export const FONT_SIZE_SUBTITLE = 10;

export const FONT_SIZE_TABLE = 9;

export const HEADER_MARGIN_TOP = 20;

export const HEADER_LINE_HEIGHT = 7;

export const HEADER_TITLE_SPACING = 2;

export const GROUP_HEADER_FILL_COLOR: [number, number, number] = [230, 230, 230];

export const GROUP_HEADER_TEXT_COLOR: [number, number, number] = [50, 50, 50];

export const LINE_COLOR: [number, number, number] = [200, 200, 200];

export const TABLE_MARGIN_TOP = 8;

export const MARGIN_LEFT = 14;

export const CONTINUED_HEADER_Y = 10;

export const DATE_COLUMN_WIDTH = 28;

export const DURATION_COLUMN_WIDTH = 24;

export const TYPE_COLUMN_WIDTH = 24;

export const MINUTES_PER_HOUR = 60;
